import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

class FacturasDialog extends Component {
  render() {
    const { t } = this.props;
    return(
      <div>
        <button
          className="hidden"
          data-target="#FacturasSuccess"
          data-toggle="modal"
          id="btnFacturas"
          type="button">
        </button>
        <div className="modal fade" id="FacturasSuccess" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <p>
                    PARA CONTINUAR CON EL PROCESO DE FACTURACION FAVOR DE ENVIAR LA CEDUDLA AL SIGUIENTE CORREO Y EL NUMERO DE FOLIO
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-default"
                  data-dismiss="modal"
                  type="button">
                  {t('dashboard.room_payment.btn_success')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(FacturasDialog);



// WEBPACK FOOTER //
// ./src/store/Payment/FacturasDialog.js